<mat-drawer-container autosize class="org-drawer-container">
    <app-org-header />

    <div class="breadcrumb">
        <app-org-breadcrumb (clickNodeEvent)="changeNodeByBreadcrumb($event)" [node]="rootNode" />
    </div>

    <div #itemContainer [ngClass]="{ 'drawer-open': isDrawerOpen }" id="main-container">
        @if (rootNode) {
            <div id="parent">
                <div>
                    @if (rootNode?.orgDescription && !rootNode?.topMostItem) {
                        <div
                            (click)="
                                changeNode(
                                    rootNode.orgLevel > 1 ? rootNode.parentOrgCode : null,
                                    rootNode.orgCode && rootNode.responsibleType
                                )
                            "
                            class="clickable"
                            style="margin-bottom: 15px"
                        >
                            <span class="icon-chevron-up"></span>
                        </div>
                    }

                    @if (rootNode?.orgDescription) {
                        <app-org-tree-node
                            (editNode)="openDialogModify($event)"
                            (openNode)="!rootNode.isDisabled && toggleDrawer($event)"
                            [currentNode]="rootNode"
                            [isActive]="isDrawerOpen && selectedItem?.id === rootNode?.id"
                            [isEditActive]="guardService.isAdmin && isEditActive"
                            [isParent]="true"
                            [isDisabled]="rootNode.isDisabled"
                            [ngClass]="{ lineBelow: rootNode?.children?.length || isCascadingAllowed }"
                        />
                    }
                </div>
            </div>
        }

        <div id="list">
            <ul id="{{ rootNode?.orgCode }}">
                <!-- show all current organizations -->
                @for (node of rootNode?.children; track node) {
                    <li class="children">
                        <div class="leftLine"></div>
                        @if ($last) {
                            <div>{{ detectWrap() }}{{ setIsWrapped() }}</div>
                        }
                        <app-org-tree-node
                            (clickNodeEvent)="!node.isDisabled && nodeClicked($event)"
                            (deleteNode)="!node.isDisabled && nodeDeleted($event)"
                            (editNode)="!node.isDisabled && openDialogModify($event)"
                            (openNode)="!node.isDisabled && toggleDrawer($event)"
                            (reset)="!node.isDisabled && resetNode($event)"
                            (unPublish)="!node.isDisabled && unPublishNode($event)"
                            [currentNode]="node"
                            [isDisabled]="node.isDisabled"
                            [isActive]="isDrawerOpen && selectedItem?.id === node?.id"
                            [isEditActive]="isEditActive"
                            [ngClass]="{
                                lineAbove: rootNode?.children?.length >= 1 || rootNode?.orgCode || isCascadingAllowed
                            }"
                        />
                    </li>
                }

                <!-- create a new organization -->
                @if (isCascadingAllowed) {
                    <li class="children create-org-container">
                        @if (rootNode) {
                            <div class="lineAbove" style="width: 100%; height: 100%">
                                <div (click)="openDialogModify()" class="create-org">
                                    <span class="icon-plus-large"></span>
                                    <span style="font-weight: bold; margin-left: 10px; font-size: 20px">{{
                                        'organisation.create' | translate
                                    }}</span>
                                </div>
                            </div>
                        } @else {
                            <div (click)="openDialogModify()" class="create-org">
                                <span class="icon-plus-large"></span>
                                <span style="font-weight: bold; margin-left: 10px; font-size: 20px">{{
                                    'organisation.create' | translate
                                }}</span>
                            </div>
                        }
                    </li>
                }

                <!-- to help center -->
                @if (isWrapped) {
                    @for (i of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]; track i) {
                        <li style="width: 280px"></li>
                    }
                }
            </ul>
        </div>
    </div>

    <app-org-drawer />
</mat-drawer-container>
